import { Directive, ElementRef, inject, input, OnChanges } from '@angular/core';
import { NotificationImportanceLevel } from 'src/app/core/api/models/notification-importance-level';

@Directive({
  selector: '[notificationsIcon]',
  standalone: true,
})
export class NotificationsIconDirective implements OnChanges {
  private element = inject<ElementRef<HTMLElement>>(ElementRef);

  readonly importanceLevel = input<NotificationImportanceLevel>(undefined, {
    alias: 'notificationsIcon',
  });

  ngOnChanges(): void {
    this.element.nativeElement.className = this.getCssClassList();
  }

  getCssClassList() {
    let icon = 'mdi flex-center size-9 shrink-0 rounded-lg text-[20px] ';
    switch (this.importanceLevel()) {
      case NotificationImportanceLevel.NormalImportance:
        icon += 'bg-warning-soft dark:bg-muted text-warning mdi-alert-outline';
        break;
      case NotificationImportanceLevel.HighImportance:
        icon += 'bg-danger-soft dark:bg-muted text-danger mdi-car-brake-alert';
        break;
      default:
        icon +=
          'bg-primary-soft dark:bg-muted text-primary dark:text-primary-300 mdi-bell-outline';
        break;
    }

    return icon;
  }
}
